<template>
  <div class="content">
    <div class="content-header">为了保障您的账号安全，请补充手机信息</div>
    <van-field
      v-model="phone"
      :border="false"
      type="number"
      maxlength="11"
      :class="showPhoneError ? 'border_error' : 'border_normal'"
      placeholder="请输入手机号"
    >
      <template #label>
        <icon-svg class="phone" name="user-phone" />
        <span class="code">+86</span>
      </template>
    </van-field>
    <van-field
      v-model="sms"
      :border="false"
      type="number"
      maxlength="11"
      :class="showsmsError ? 'border_error' : 'border_normal'"
      placeholder="请输入短信验证码"
    >
      <template #button>
        <div class="btn-text" @click="getSms">{{ btnText }}</div>
      </template>
    </van-field>
    <div class="err-text" :style="{ opacity: showError ? 1 : 0 }">
      手机号或验证码错误，请重新输入
    </div>
    <van-button
      class="submit-btn"
      :disabled="!(phone && sms)"
      round
      color="#3476FE"
      type="info"
      block
      @click="toSubmit"
      >
      确认
    </van-button>
    <van-number-keyboard
      v-model="phone"
      theme="custom"
      close-button-text="完成"
      :show="showPhoneKeyboard"
    />
    <van-number-keyboard
      v-model="sms"
      theme="custom"
      close-button-text="完成"
      :show="showSmsKeyboard"
      @blur="showSmsKeyboard = false"
    />
  </div>
</template>
<script>
import cookies from "@/libs/util.cookies";

export default {
  data() {
    return {
      show: false,
      phone: "",
      sms: "",
      timer: null,
      second: 30,
      firstGetMss: true,
      showError: false,
      showPhoneError: false,
      showsmsError: false,
      showPhoneKeyboard:false,
      showSmsKeyboard:false,
    };
  },
  computed: {
    btnText() {
      if (!this.timer) {
        return this.firstGetMss ? "发送验证码" : "重新获取";
      } else {
        return `${this.second}秒后重新获取`;
      }
    },
  },
  methods: {
    getSms() {
      const reg = /^1[3456789]\d{9}$/;
      if (!reg.test(this.phone)) {
        this.showPhoneError = true;
        this.showError = true;
        return;
      }
      this.firstGetMss = false;
      this.showPhoneError = false;
      this.showError = false;
      if (this.timer) {
        return;
      } else {
        const data = {
          mobile: this.phone,
          valid_img_req_id: "1",
          width: 0,
          valid_code_type: "BIND_MOBILE",
        };
        this.$api.GET_SMS(data).then(
          () => {
            this.timer = setInterval(() => {
              this.second--;
              if (this.second < 1) {
                clearInterval(this.timer);
                this.timer = null;
                this.second = 30;
              }
            }, 1000);
          },
          (err) => {
            this.$toast(err);
          }
        );
      }
    },
    toSubmit() {
      const data = {
        mobile: this.phone,
        valid_code: this.sms,
      };
      this.$api.BIND_MOBILE(data).then(
        (res) => {
          res.access_token &&
            cookies.set("token", `Bearer ${res.access_token}`);
          res.refresh_token && cookies.set("refresh_token", res.refresh_token);
          this.$store.dispatch("user/getUserInfo");
          this.$toast("绑定成功");
          this.$router.back();
        },
        (err) => {
          console.log(err);
        }
      );
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep {
  .van-action-sheet__header {
    color: #fff;
  }
  .van-field__label {
    width: auto;
    align-items: center;
    display: flex;
  }
  .van-cell {
    padding: 12px 10px;
  }
}
.content {
  padding: 0 20px 20px;
  height: 100%;
  box-sizing: border-box;
  background: #fff;
  &-header {
    font-size: 20px;
    font-weight: 600;
    color: #333333;
    padding-top: 80px;
  }
  .phone {
    width: 24px;
    height: 24px;
  }
  .code {
    color: #333;
    font-size: 16px;
    padding: 0 10px;
    border-right: 1px solid #eaedf0;
  }
  .err-text {
    font-size: 14px;
    color: #fe6868;
    margin-top: 15px;
  }
  .submit-btn {
    margin-top: 80px;
  }
  .border_error {
    border-radius: 8px;
    border: 1px solid #fe6868;
    margin-top: 15px;
  }
  .border_normal {
    border-radius: 8px;
    border: 1px solid #eaedf0;
    margin-top: 15px;
  }
  .btn-text {
    font-size: 14px;
    color: #3476fe;
  }
  .icon-dhp {
    width: 100%;
    margin-top: 20px;
  }
}
</style>
